import React, { useEffect, useContext, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import {
  MobileFriendly as MobileFriendlyIcon,
  ContactEmergency as ContactEmergencyIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';

function ModalPreRegisterForm() {
  const { t } = useTranslation();

  const {
    updateFocusOnMainScreen,
    updateShowPreRegisterForm,
    updateIsFullUserRegistration,
    updateShowBankIDForm,
    isEnabledBankID,
  } = useContext(AppContext);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const isEnabledBankIDRef = useRef(isEnabledBankID);
  useEffect(() => {
    isEnabledBankIDRef.current = isEnabledBankID;
  }, [isEnabledBankID]);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {}, [socket]);

  //* CANCEL BUTTON (close the modal and go back to main screen)
  const handleCancel = () => {
    updateFocusOnMainScreen(true);
    updateShowPreRegisterForm(false);
  };

  const handleNewMemberByID = () => {
    updateFocusOnMainScreen(false);
    updateIsFullUserRegistration(true);
    updateShowPreRegisterForm(false);
  };

  const handleNewMemberByBankID = () => {
    if (!isEnabledBankIDRef.current) {
      return;
    }
    updateFocusOnMainScreen(false);
    updateShowBankIDForm(true);
    updateShowPreRegisterForm(false);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.newMember')}</h1>
            <p>{t('sales.newMemberText')}</p>
            <div className="react-confirm-alert-button-group">
              <button
                className="btn-custom-yes"
                onClick={() => {
                  handleNewMemberByID();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <ContactEmergencyIcon style={{ fontSize: '1.2em' }} />

                {t('sales.newMemberButtonID')}
              </button>

              <button
                className="btn-custom-yes"
                onClick={() => {
                  handleNewMemberByBankID();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                  opacity: isEnabledBankIDRef.current ? 1 : 0.5,
                }}
              >
                <MobileFriendlyIcon style={{ fontSize: '1.2em' }} />

                {t('sales.newMemberButtonBankID')}
              </button>

              <button
                className="btn-custom-no"
                onClick={() => {
                  handleCancel();
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px', // Space between icon and text
                }}
              >
                <CancelIcon style={{ fontSize: '1.2em' }} />

                {t('sales.cancel')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalPreRegisterForm;
